<template>
  <section :id class="container">
    <AddressCard :address />
  </section>
</template>

<script lang="ts" setup>
import type { ParagraphAddressFragment } from '#graphql-operations'

defineProps<ParagraphAddressFragment>()

const { index, siblings } = defineBlokkli({
  bundle: 'address',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
})

const id = useParagraphAnchorId(index, siblings)
</script>

<style></style>
